<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/clQqJ0/cover.jpeg?1725276967935" alt="This image is the cover for the book A Year in the Life of Rebecca Saunders"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Year in the Life of Rebecca Saunders
      </h1>
      <p class="bookDescription body article font2">
        <p>New beginnings and a dark secret collide in Rebecca Saunders’ chaotic world. Frustrated by a jobless husband, unruly children, and rambunctious dogs, Becky seeks refuge in a quirky job working for Leo, a blustery wine importer with an attic office in his grand home. Leo’s wife, Fizz, adds to the unpredictable mix with her eccentric personality and champagne-cork temperament. Amidst the swirling chaos, Becky discovers a hidden secret that threatens the heart of her newfound sanctuary. Can she navigate the tangled vines of her own life while preserving the fragile peace she’s found?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susie King
      </h2>
      
      <p class="authorDescription body article">Susie King has always loved writing stories and is highly imaginative, with a keen sense of the drama of life. Susie has been a chalet girl, daffodil picker, au pair, MP’s secretary, natural health therapist and went to a convent school where she was always getting into trouble. She loves travelling, going to the movies, trees, fish & chips, snow, the sea and anything to do with space.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5d556692